<div class="cad-list" [class.cad-list--compact]="compact">
  <div class="cad-list__header">
    <span class="cad-list__title"><i class="bi bi-file-earmark-ruled"></i> {{ title }}</span>
    <label class="cad-list__upload" *ngIf="canEdit" [class.disabled]="uploading">
      <i class="bi" [ngClass]="uploading ? 'bi-hourglass-split' : 'bi-upload'"></i>
      {{ uploading ? 'Uploading…' : 'Upload DWG/DXF' }}
      <input type="file" hidden [accept]="accept" [disabled]="uploading" (change)="onFileSelected($event)" />
    </label>
  </div>

  <div class="cad-list__error" *ngIf="error">{{ error }}</div>

  <div class="cad-list__hint" *ngIf="!dwgSupported">
    DWG preview isn't available on this server yet. DXF files can still be viewed.
  </div>

  <div class="cad-list__empty" *ngIf="!loading && !drawings.length && !error">
    No drawings yet{{ canEdit ? ' — upload a .dwg or .dxf file.' : '.' }}
  </div>
  <div class="cad-list__empty" *ngIf="loading">Loading drawings…</div>

  <ul class="cad-list__items" *ngIf="drawings.length">
    <li
      *ngFor="let d of drawings"
      class="cad-list__item"
      [class.cad-list__item--active]="selectMode && d.id === selectedId"
      (click)="open(d)"
      [title]="'Open ' + d.original_name"
    >
      <span class="cad-list__badge">{{ d.format | uppercase }}</span>
      <span class="cad-list__name">{{ d.original_name }}</span>
      <span class="cad-list__meta">{{ formatSize(d.file_size) }} · {{ d.created_at | date: 'dd MMM yyyy' }}</span>
      <a class="cad-list__icon" [href]="d.file_url" target="_blank" rel="noopener" download (click)="$event.stopPropagation()" title="Download">
        <i class="bi bi-download"></i>
      </a>
      <button type="button" class="cad-list__icon cad-list__icon--danger" *ngIf="canEdit" (click)="remove(d, $event)" title="Delete">
        <i class="bi bi-trash"></i>
      </button>
    </li>
  </ul>
</div>
